'use strict';

/**
 * Ordered by display preference (US regions group first, alphabetically by region group otherwise).
 *
 * Update: Clients (e.g. GUI) should manage their own ordered list, and once this is completed the comment above should
 * be removed. Though there is nothing wrong with keeping the current order in this file.
 *
 */

module.exports = {
    usEast1: 'us-east-1',
    usEast2: 'us-east-2',
    usWest1: 'us-west-1',
    usWest2: 'us-west-2',
    usGovEast1: 'us-gov-east-1',
    usGovWest1: 'us-gov-west-1',

    afSouth1: 'af-south-1',

    apEast1: 'ap-east-1',
    apSouth1: 'ap-south-1',
    apNortheast3: 'ap-northeast-3',
    apNortheast2: 'ap-northeast-2',
    apSoutheast1: 'ap-southeast-1',
    apSoutheast2: 'ap-southeast-2',
    apNortheast1: 'ap-northeast-1',

    caCentral1: 'ca-central-1',

    cnNorth1: 'cn-north-1',
    cnNorthwest1: 'cn-northwest-1',

    euCentral1: 'eu-central-1',
    euWest1: 'eu-west-1',
    euWest2: 'eu-west-2',
    euSouth1: 'eu-south-1',
    euWest3: 'eu-west-3',
    euNorth1: 'eu-north-1',

    meSouth1: 'me-south-1',

    saEast1: 'sa-east-1'
};